<div mat-dialog-title class="modal-title">
  <mat-icon>query_stats</mat-icon>
  <span>Ventas del afiliado: {{ fullname }}</span>
  <mat-icon class="close-button" (click)="closeModal()"> cancel </mat-icon>
</div>
<mat-dialog-content>
  @if (isLoadingAffiliate && !affiliateAnalytics) {
    <div class="loading-page">
      <mat-spinner color="primary"></mat-spinner>
    </div>
  }
  @if (!isLoadingAffiliate && !affiliateAnalytics) {
    <div class="no-current"> No hay estadísticas disponibles para este afiliado </div>
  }
  @if (!isLoadingAffiliate && affiliateAnalytics) {
    <div class="analytics">
      <mat-tab-group mat-align-tabs="start" [animationDuration]="0" class="analytics-tab-group">
        <mat-tab label="Estadísticas">
          <div class="filter-sales">
            <div class="header">Filtrar ventas</div>
            <div class="content">
              <form [formGroup]="filterSalesForm">
                <div class="row">
                  <div class="col-12 col-lg-4">
                    <div class="form-control">
                      <mat-form-field color="primary" appearance="outline">
                        <mat-label>Fecha de inicio</mat-label>
                        <input matInput type="date" placeholder="Fecha de inicio" formControlName="startDate" name="startDate" autocomplete="off" />
                        <mat-error>Fecha de inicio requerida</mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-12 col-lg-4">
                    <div class="form-control">
                      <mat-form-field color="primary" appearance="outline">
                        <mat-label>Fecha de finalización</mat-label>
                        <input matInput type="date" placeholder="Fecha de finalización" formControlName="endDate" name="endDate" autocomplete="off" />
                        @if (filterSalesForm.controls.endDate.hasError('dateIsBefore')) {
                          <mat-error>La fecha de finalización no puede ser anterior a la de inicio</mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-12 col-lg-4">
                    <div class="form-control">
                      <mat-form-field color="primary" appearance="outline">
                        <mat-label>Granularidad</mat-label>
                        <mat-select formControlName="granularity" placeholder="Selecciona una">
                          <mat-option value="day"> Día </mat-option>
                          <mat-option value="month"> Mes </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="filter">
                    <button mat-flat-button color="primary" (click)="filterSales()" [disabled]="filterSalesForm.invalid || isFiltering">
                      @if (!isFiltering) {
                        <span>Filtrar</span>
                      } @else {
                        <mat-spinner class="white-spinner"></mat-spinner>
                      }
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          @if (affiliateAnalytics.groupedOrders) {
            <div class="month-sales-graphic">
              <div class="header">
                Gráfico de ventas de <span>{{ currentSalesText }}</span
                >:
                {{ affiliateAnalytics.totalFee | currency: 'EUR' : 'symbol' : '1.0-2' }}
              </div>
              <div class="content">
                @if (!affiliateAnalytics.groupedOrders.length) {
                  <div class="no-current"> No hay ventas disponibles </div>
                } @else {
                  <div class="chart">
                    <canvas id="monthSalesBarChart">
                      {{ monthSalesBarChart }}
                    </canvas>
                  </div>
                }
              </div>
            </div>
          }

          <div class="orders-header">
            Órdenes de <span>{{ currentSalesText }}</span
            >:
            {{ affiliateAnalytics.totalFee | currency: 'EUR' : 'symbol' : '1.0-2' }}
          </div>

          @if (!affiliateAnalytics.orders.length) {
            <div class="no-current-orders">No hay órdenes de compra disponibles</div>
          }

          @if (affiliateAnalytics.orders.length && screenWidth < 992) {
            <div class="orders">
              @for (order of affiliateAnalytics.orders; track order.orderId) {
                <div class="order">
                  <p> <b>Pedido: </b> # {{ order.orderId }} </p>
                  <p class="date"> <b>Fecha: </b> {{ order.date | date: 'dd MMM yyyy' : '' : 'es' }} </p>
                  <p> <b>Cliente: </b> {{ order.user.name }} {{ order.user.lastname }} ({{ order.user.email }}) </p>
                  <div class="products">
                    <div class="text">
                      <b>Productos:</b>
                    </div>
                    <div class="list">
                      @for (product of order.products; track product.productId) {
                        <li>{{ product.name }}: {{ product.price | currency: 'EUR' : 'symbol' : '1.0-2' }}</li>
                      }
                    </div>
                  </div>
                  <p>
                    <b>Método de pago: </b>
                    @if (order.paymentMethod === 'paypal') {
                      <span>PayPal</span>
                    } @else if (order.paymentMethod === 'stripe') {
                      <span>Stripe</span>
                    } @else if (order.paymentMethod === 'bank') {
                      <span>T. Bancaria</span>
                    } @else if (order.paymentMethod === 'hotmart') {
                      <span>Hotmart</span>
                    } @else if (order.paymentMethod === 'free') {
                      <span>Gratis</span>
                    }
                  </p>
                  <p> <b>Total: </b> {{ order.total | currency: 'EUR' : 'symbol' : '1.0-2' }} </p>
                  <p> <b>Comisión del afiliado:</b> {{ order.affiliateFee | currency: 'EUR' : 'symbol' : '1.0-2' }} </p>
                  <p> <b>Porcentaje de comisión: </b> {{ order.affiliateFeePercentage }} % </p>
                </div>
              }
            </div>
          }

          @if (affiliateAnalytics.orders.length && screenWidth >= 992) {
            <div class="orders-table">
              <table class="orders-table">
                <thead>
                  <tr>
                    <th class="order">Pedido</th>
                    <th class="name">Cliente</th>
                    <th class="products">Productos</th>
                    <th class="method">Método de pago</th>
                    <th class="total">Total</th>
                    <th class="fee">Comisión del afiliado</th>
                    <th class="fee">Porcentaje de comisión</th>
                  </tr>
                </thead>
                <tbody>
                  @for (order of affiliateAnalytics.orders; track order.orderId; let i = $index) {
                    <tr>
                      <td class="order">
                        <span># {{ order.orderId }}</span>
                        <span>{{ order.date | date: 'dd MMM yyyy' : '' : 'es' }}</span>
                      </td>
                      <td class="name">
                        <span>{{ order.user.name }} {{ order.user.lastname }}</span>
                        <span>{{ order.user.email }}</span>
                      </td>
                      <td class="products">
                        @if (order.products.length === 1) {
                          <div>
                            <span>
                              {{ order.products[0].name }}
                            </span>
                          </div>
                        }
                        @if (order.products.length > 1) {
                          <div>
                            @for (product of order.products; track product.productId) {
                              <li>
                                {{ product.name }}
                              </li>
                            }
                          </div>
                        }
                      </td>
                      <td class="method">
                        @if (order.paymentMethod === 'paypal') {
                          <span>PayPal</span>
                        } @else if (order.paymentMethod === 'stripe') {
                          <span>Stripe</span>
                        } @else if (order.paymentMethod === 'bank') {
                          <span>T. Bancaria</span>
                        } @else if (order.paymentMethod === 'hotmart') {
                          <span>Hotmart</span>
                        } @else if (order.paymentMethod === 'free') {
                          <span>Gratis</span>
                        }
                      </td>
                      <td class="total">
                        {{ order.total | currency: 'EUR' : 'symbol' : '1.0-2' }}
                      </td>
                      <td class="fee">
                        {{ order.affiliateFee | currency: 'EUR' : 'symbol' : '1.0-2' }}
                      </td>
                      <td class="fee"> {{ order.affiliateFeePercentage }} % </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </mat-tab>
        <mat-tab label="Pagos">
          <div class="payments">
            <div class="new-payment">
              <button mat-flat-button color="accent" (click)="openEditAffiliatePaymentModal()">
                <mat-icon slot="start">add_circle</mat-icon>
                <span>Nuevo pago</span>
              </button>
            </div>
            @if (!affiliateAnalytics.payments.length) {
              <div class="no-current"> No hay pagos disponibles </div>
            } @else {
              <div class="payments-list">
                @for (payment of affiliateAnalytics.payments; track payment; let i = $index) {
                  <div class="payment">
                    <div class="payment-header">
                      <span>{{ payment.name }}</span>
                      @if (payment.totalPaid === payment.totalToPay) {
                        <span class="paid">Pagado</span>
                      }
                      @if (payment.totalPaid > 0 && payment.totalPaid < payment.totalToPay) {
                        <div class="incomplete">Pago incompleto</div>
                      }
                      @if (payment.totalPaid === 0 && payment.totalPaid < payment.totalToPay) {
                        <div class="unpaid">No pagado</div>
                      }
                    </div>
                    <div class="payment-content">
                      <p class="date"> <b>Período inicia:</b> {{ payment.startDate | date: 'dd MMM yyyy' : '' : 'es' }} </p>
                      <p class="date"> <b>Período finaliza:</b> {{ payment.endDate | date: 'dd MMM yyyy' : '' : 'es' }} </p>
                      <p> <b>Total a pagar:</b> {{ payment.totalToPay | currency: 'EUR' : 'symbol' : '1.0-2' }} </p>
                      <p> <b>Total pagado:</b> {{ payment.totalPaid | currency: 'EUR' : 'symbol' : '1.0-2' }} </p>
                      <p>
                        <b>Factura:</b>
                        @if (payment.invoiceUrl) {
                          <a [href]="payment.invoiceUrl" [download]="true">Descargar factura</a>
                        } @else {
                          <span>Pendiente</span>
                        }
                      </p>
                      <div class="options">
                        <button
                          mat-icon-button
                          color="primary"
                          (click)="openAffiliatePaymentModal(payment.affiliatePaymentId, payment.totalToPay, payment.totalPaid)"
                          matTooltip="Pagar al afiliado"
                        >
                          <mat-icon>attach_money</mat-icon>
                        </button>
                        <button mat-icon-button color="primary" (click)="openEditAffiliatePaymentModal(payment)" matTooltip="Editar el pago">
                          <mat-icon>edit</mat-icon>
                        </button>
                        <button
                          mat-icon-button
                          color="warn"
                          matTooltip="Borrar el pago"
                          (click)="confirmDeletePayment(i, payment.affiliatePaymentId)"
                          [disabled]="payment.isDeleting"
                        >
                          @if (!payment.isDeleting) {
                            <mat-icon>delete</mat-icon>
                          } @else {
                            <mat-spinner class="danger-spinner"></mat-spinner>
                          }
                        </button>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  }
</mat-dialog-content>
